import * as React from 'react';

import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';
import type { InjectedRouter } from 'js/lib/connectToRouter';

import { EnterpriseAdminNotificationStorage } from 'bundles/enterprise-admin-account/utils/EnterpriseAdminNotificationStorage';
import {
  getNotificationFromMultipleContracts,
  handleNotificationButtonClick,
} from 'bundles/enterprise-admin-account/utils/NotificationUtils';
import type { NotificationData, NotificationId } from 'bundles/enterprise-admin-account/utils/NotificationUtils';
import withDecoratedEnterpriseContractsWithInvoices from 'bundles/enterprise-admin-account/utils/withDecoratedEnterpriseContractsWithInvoices';
import type { PropsFromEnhancer as PropsFromWithDecoratedEnterpriseContractsWithInvoices } from 'bundles/enterprise-admin-account/utils/withDecoratedEnterpriseContractsWithInvoices';
import EnterpriseAdminNotificationBanner from 'bundles/enterprise-admin-home/components/EnterpriseAdminNotificationBanner';
import type { EnterpriseOrganizationSummary } from 'bundles/naptimejs/resources/EnterpriseOrganizationSummaries.v1';

type PropsFromCaller = {
  thirdPartyOrganization: { id: string };
  thirdPartyOrgSummary?: EnterpriseOrganizationSummary;
  hasActiveProgram?: boolean;
};

type PropsFromRouter = {
  router: InjectedRouter;
};

type Props = PropsFromCaller & PropsFromRouter & PropsFromWithDecoratedEnterpriseContractsWithInvoices;

type State = {
  dismissed: boolean;
};

export class EnterpriseAdminNotification extends React.Component<Props, State> {
  state: State = {
    dismissed: false,
  };

  handleNotificationButtonClick = (notification: NotificationData) => () => {
    const { router } = this.props;
    const notificationId = notification.id;
    handleNotificationButtonClick(router, notificationId);
  };

  handleDismissNotification = (contractId: string, notificationId: NotificationId) => () => {
    this.setState({ dismissed: true });
    EnterpriseAdminNotificationStorage.dismiss(contractId, notificationId);
  };

  render() {
    const { dismissed } = this.state;
    const { hasActiveProgram } = this.props;

    // if dismissed, then don't show any notification for this page load
    // even if other notifications are available, they will be displayed on next page load
    // this is to prevent another notification from being displayed immediately after the 1st is dismissed
    if (dismissed) {
      return null;
    }

    const { decoratedContracts } = this.props;
    const bannerData = getNotificationFromMultipleContracts(decoratedContracts, { hasActiveProgram });

    if (bannerData?.notification?.homePage) {
      return (
        <div className="p-t-2">
          <EnterpriseAdminNotificationBanner
            severity={bannerData.notification.severity}
            title={bannerData.notification.homePage.title}
            description={bannerData.notification.homePage.description}
            buttonLabel={bannerData.notification.homePage.buttonLabel}
            onButtonClick={this.handleNotificationButtonClick(bannerData.notification)}
            onDismiss={this.handleDismissNotification(bannerData.contract.id, bannerData.notification.id)}
          />
        </div>
      );
    }

    return null;
  }
}

export default compose<Props, PropsFromCaller>(
  connectToRouter((router) => ({ router })),
  withDecoratedEnterpriseContractsWithInvoices
)(EnterpriseAdminNotification);
